module.exports = "/_next/static/chromiums/twitter-512x512-products-variety-lip-balm-fbe2387a1e8d160c2b4081dbbb67b053.jpg";